import { api, baseUrl,  } from '../../api';

export const createDeviceToken = async (data:any) => {
    const result = await api.post(`${baseUrl}/shared/device-token`,data);
    return result;
};